module.exports = __webpack_public_path__ + "img/master-card.e2ca8957.svg";